<div
  class="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-blue-50 flex flex-col lg:flex-row relative"
>
  <!-- Background Image (visible in mobile and tablet) -->
  <div class="absolute inset-0 lg:hidden animate-fade-in">
    <div
      class="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60 backdrop-blur-[2px] z-10"
    ></div>
    <img
      src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
      alt="Server room"
      class="h-full w-full object-cover"
      loading="eager"
    />
  </div>

  <!-- Left side - Login Form -->
  <div
    class="w-full lg:w-1/2 min-h-screen flex flex-col px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 relative z-20 animate-fade-in"
    style="animation-delay: 200ms"
  >
    <!-- Main content wrapper with vertical centering -->
    <div class="flex-1 flex flex-col justify-center py-8 sm:py-12">
      <!-- Logo and form container -->
      <div class="w-full max-w-md mx-auto space-y-6 sm:space-y-8">
        <!-- Logo and Title -->
        <div class="flex flex-col items-center space-y-4 sm:space-y-6">
          <div class="relative group">
            <div
              class="relative rounded-full overflow-hidden animate-fade-in"
              style="animation-delay: 400ms"
            >
              <img
                src="assets/LOGO.png"
                alt="Feed Me Logo"
                class="h-24 w-24 sm:h-28 sm:w-28 md:h-32 md:w-32 object-contain transition-transform duration-300 group-hover:scale-105"
              />
            </div>
          </div>
          <div class="text-center">
            <h2
              class="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white lg:text-secondary animate-fade-in"
              style="animation-delay: 600ms"
            >
              FeedMe
            </h2>
            <p
              class="mt-2 text-sm sm:text-base text-gray-200 lg:text-gray-600 animate-fade-in"
              style="animation-delay: 800ms"
            >
              Il feedback facile e veloce
            </p>
          </div>
        </div>

        <!-- Login Form Container -->
        <div
          class="bg-white/90 lg:bg-white/50 backdrop-blur-md rounded-2xl p-6 sm:p-8 shadow-xl border border-white/20 transition-all duration-300 hover:shadow-2xl hover:border-white/30 animate-fade-in"
          style="animation-delay: 1000ms"
        >




            <button
              (click)="login()"
              class="w-full flex justify-center items-center py-3 sm:py-3.5 px-4 border border-transparent rounded-xl shadow-sm text-sm sm:text-base font-medium text-white bg-secondary hover:bg-secondary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary transition-all duration-300 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Accedi
            </button>

        </div>
      </div>
    </div>
  </div>

  <!-- Right side - Desktop Background (hidden on mobile) -->
  <div
    class="hidden lg:block lg:w-1/2 relative overflow-hidden animate-fade-in"
  >
    <div class="absolute inset-0">
      <div
        class="absolute inset-0 bg-gradient-to-r from-black/30 to-black/10 backdrop-blur-[1px] z-10"
      ></div>
      <img
        src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
        alt="Server room"
        class="h-full w-full object-cover"
        loading="lazy"
      />
    </div>
  </div>
</div>

<style>
    @keyframes shake {
        0%,
        100% {
            transform: translateX(0);
        }
        25% {
            transform: translateX(-4px);
        }
        75% {
            transform: translateX(4px);
        }
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .animate-fade-in {
        opacity: 0;
        animation: fadeIn 0.6s ease-out forwards;
    }

    .animate-shake {
        animation: shake 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    }
</style>
